<div [@inOutAnimation] class="flex flex-col justify-center items-center fixed inset-0 z-[1100] bg-black bg-opacity-80"
    *ngIf="formLoading">

    <div class="animate animate-ping text-white text-4xl">{{env.title}}</div>
    <div class="text-white mt-5">{{formLoading}}</div>
</div>